import { z } from "zod"

export interface PriceList {
  id: string
  name: string
  isDefault: boolean
  isActive: boolean
  storeId: string
  hourlyPrice: number
}

export const CreatePriceListSchema = z.object({
  name: z.string().min(1).max(255),
})

export type CreatePriceList = z.infer<typeof CreatePriceListSchema>

export const UpdatePriceListSchema = z.object({
  name: z.string().min(1).max(255).optional(),
  hourlyPrice: z.number().int().min(0).optional(),
  isActive: z.boolean().optional(),
})

export type UpdatePriceList = z.infer<typeof UpdatePriceListSchema>
